define(["require", "exports", "tslib", "vue"], function (require, exports, tslib_1, vue_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DirectiveWave = void 0;
    vue_1 = (0, tslib_1.__importDefault)(vue_1);
    var DirectiveWave = (function (_super) {
        (0, tslib_1.__extends)(DirectiveWave, _super);
        function DirectiveWave() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DirectiveWave.prototype.bind = function (el, binding, vnode) {
            el.addEventListener('click', function (e) {
                var customOpts = (0, tslib_1.__assign)({}, binding.value);
                var opts = (0, tslib_1.__assign)({ ele: el, type: 'hit', color: 'rgba(0, 0, 0, 0.15)' }, customOpts);
                var target = opts.ele;
                if (target) {
                    target.style.position = 'relative';
                    target.style.overflow = 'hidden';
                    var rect = target.getBoundingClientRect();
                    var ripple = target.querySelector('.waves-ripple');
                    if (!ripple) {
                        ripple = document.createElement('span');
                        ripple.className = 'waves-ripple';
                        ripple.style.height = ripple.style.width = "".concat(Math.max(rect.width, rect.height), "px");
                        target.appendChild(ripple);
                    }
                    else {
                        ripple.className = 'waves-ripple';
                    }
                    switch (opts.type) {
                        case 'center':
                            var rippleCenterTop = rect.height / 2 - ripple.offsetHeight / 2;
                            ripple.style.top = "".concat(rippleCenterTop, "px");
                            var rippleCenterLeft = rect.width / 2 - ripple.offsetWidth / 2;
                            ripple.style.left = "".concat(rippleCenterLeft, "px");
                            break;
                        default:
                            var rippleStyleTop = (e.pageY - rect.top - ripple.offsetHeight / 2 - document.documentElement.scrollTop || document.body.scrollTop);
                            var rippleStyleLeft = (e.pageX - rect.left - ripple.offsetWidth / 2 - document.documentElement.scrollLeft || document.body.scrollLeft);
                            ripple.style.top = "".concat(rippleStyleTop, "px");
                            ripple.style.left = "".concat(rippleStyleLeft, "px");
                    }
                    ripple.style.backgroundColor = opts.color;
                    ripple.className = 'waves-ripple z-active';
                    return false;
                }
            }, false);
        };
        return DirectiveWave;
    }(vue_1.default));
    exports.DirectiveWave = DirectiveWave;
});
//# sourceMappingURL=DirectiveWave.js.map